// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6T_NX","type":"styles_type__d8Ukd","choices":"styles_choices__2BBVh"};